export const include = {
  name: "include",
  type: "word",
  parseWordCondition: () => true,
  parseWordAction: (word) => word,
  format: (text) => text,
  label: "Inclure les mots suivants",
  isDefault: true,
};
